export default {
	'search-item-id-or-name': 'Search Item Id or Name',
	'show-main-item': 'Shwow Main Item',
	'items-with-quantities-only': 'Items with quantities only',
	'store-items': 'Store',
	'inventory-matching': 'Inventory matching'
}